import {
  DraftBroadcast,
  Broadcast,
  ScheduleTime,
} from 'models/broadcast.model';
import { Attachment } from 'interfaces';

export type DraftBroadcastKeys = Record<keyof DraftBroadcast, string>;
export type DraftBroadcastValidationField = Record<
  keyof Pick<
    DraftBroadcastKeys,
    'title' | 'message' | 'tagIds' | 'schedule' | 'scheduleTime'
  >,
  string
>;

export const TAB_STATUSES = {
  IN_PROGRESS: 'In progress',
  PUBLISHED: 'Published',
};

export const BROADCAST_TABS = {
  PREVIEW: 'broadcast-preview',
  COMMENTS: 'broadcast-comments',
  PROGRESS: 'broadcast-progress',
} as const;

export type BroadcastState = {
  inProgressBroadcasts: Broadcast[];
  publishedBroadcasts: Broadcast[];
  draft: Broadcast;
  errors: DraftBroadcastKeys;
  activeTab: string;
  activeBroadcastTab: string;
};

export type DraftSetOptions = {
  markAsDirty?: boolean;
  shouldValidate?: boolean;
};

export type BroadcastActions = {
  actions: {
    setDraftTitle: (title: string, options?: DraftSetOptions) => void;
    setDraftMessage: (message: string, options?: DraftSetOptions) => void;
    setDraftTagIds: (tagIds: string[], options?: DraftSetOptions) => void;
    setDraftUserRoles: (userRoles: string[], options?: DraftSetOptions) => void;
    setDraftScheduleDate: (
      scheduleDate: string,
      options?: DraftSetOptions,
    ) => void;
    setDraftScheduleTime: (
      scheduleTime: ScheduleTime,
      options?: DraftSetOptions,
    ) => void;
    setDraftPictures: (files: Attachment[], options?: DraftSetOptions) => void;
    setActiveTab: (tab: string) => void;
    setActiveBroadcastTab: (tab: string) => void;
  };
};
